import {Link} from 'react-router-dom'
import DesignExterno from '../components/DesignExterno/DesignExterno'

export const UserRequest = () => {
  return (
    <DesignExterno title={<span> Crea tu cuenta</span>}>
      <section className='centrar-horizontal' style={{width: '100%', maxWidth: '600px'}}>
        <div className='w-form'>
          <Link to='/'>
            <span className='back-button w-inline-block' />
          </Link>
          <div
            id='email-form'
            className='form-content'
            data-wf-page-id='64af252d3146e7d5debe0888'
            data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
          >
            <div>
              <h2 className='h2-titles'>¡Solicitud Enviada!</h2>
              <div>
                Tu solicitud de usuario se ha enviado exitosamente. Te informaremos cuando tu
                solicitud haya sido procesada. Contacta tu Supervisor para que la apruebe.
              </div>
            </div>
            <div className='form-separator'></div>
            <div className='m buttons-div'>
              <Link to='/' className='m button w-inline-block'>
                <div>Aceptar</div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </DesignExterno>
  )
}
